import { render, staticRenderFns } from "./LayoutBase.vue?vue&type=template&id=dd616220&scoped=true&"
import script from "./LayoutBase.vue?vue&type=script&lang=js&"
export * from "./LayoutBase.vue?vue&type=script&lang=js&"
import style0 from "./LayoutBase.vue?vue&type=style&index=0&id=dd616220&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd616220",
  null
  
)

export default component.exports